window.disney = window.disney || {}, window.disney.util = {
    getCookie: function(e) {
        var n, o = e + "=";
        try {
            n = decodeURIComponent(document.cookie).split(";");
        } catch (e) {
            return console.logRAError && console.logRAError("Error parsing cookie string: " + e), 
            "";
        }
        for (var i = 0; i < n.length; i++) {
            for (var r = n[i]; " " === r.charAt(0); ) r = r.substring(1);
            if (0 === r.indexOf(o)) return r.substring(o.length, r.length);
        }
        return "";
    }
}, window.disney.nativeBridge = function(e) {
    var i = e.platform;
    return {
        sendCustomMessage: function(e, n, o) {
            s(r(e, n, o));
        },
        sendReadyMessage: function(e, n) {
            s(r("disneyRAWebViewBridgeReady", e, n));
        },
        sendErrorMessage: function(e, n) {
            s(r("disneyRAWebViewBridgeError", e, n));
        },
        sendCloseMessage: function(e, n) {
            s(r("disneyRAWebViewBridgeClose", e, n));
        }
    };
    function r(e, n, o) {
        return {
            commandName: e,
            params: n,
            sendFailedCallback: o
        };
    }
    function s(n) {
        if (n) {
            console.logRADebug && console.logRADebug("nativeBridge::sendMessage - message", n);
            var o = n.sendFailedCallback || function() {};
            if (delete n.sendFailedCallback, "ios" === i) if (void 0 !== window.webkit) try {
                window.webkit.messageHandlers.disneyRAWebViewBridge.postMessage(n);
            } catch (e) {
                console.logRAError && console.logRAError("iOS disneyRAWebViewBridge send failed: ", n), 
                o(n.commandName, n.params, e);
            } else {
                var e = new Error("Could not find window.webkit");
                o(n.commandName, n.params, e);
            } else if ("android" === i) try {
                window.disneyRAWebViewBridge.postMessage(n.commandName, JSON.stringify(n.params), null);
            } catch (e) {
                console.logRAError && console.logRAError("Android disneyRAWebViewBridge send failed", n), 
                o(n.commandName, n.params, e);
            } else if ("flutter" === i) try {
                window.disneyRAWebViewBridge.postMessage(JSON.stringify(n));
            } catch (e) {
                console.logRAError && console.logRAError("Flutter disneyRAWebViewBridge send failed: ", n), 
                o(n.commandName, n.params, e);
            }
        }
    }
}, function() {
    var e = "DisneyRAWebView";
    function n() {
        return window.navigator.userAgent;
    }
    var o = (window.disney.getUserAgent = n)();
    window.disney.device = {
        platform: {
            ios: -1 !== o.indexOf("DisneyRAWebView/iOS"),
            android: -1 !== o.indexOf("DisneyRAWebView/Android"),
            flutter: -1 !== o.indexOf("DisneyRAWebView/Flutter")
        },
        embedded: -1 !== o.indexOf(e)
    };
}(), window.disney.nativeBridgeFactory = function() {
    var o = window.console;
    return {
        createNativeBridge: function() {
            (n = window.disney.getUserAgent().match("DisneyRAWebView/([^s]+)")) && 1 < n.length && (e = n[1].trim().toLowerCase());
            var e, n = new window.disney.nativeBridge({
                platform: e
            });
            return window.disney.plugins.logger(n, o), window.disney.plugins.webErrorLogger(n, window), 
            n;
        }
    };
}(), window.disney.loadEnvironmentData = function() {
    var i;
    return function() {
        var e = "/environments/" + (window.disney.util.getCookie("envName") || "prd") + ".json", n = {};
        return (i = new XMLHttpRequest()).onload = function() {
            if (4 === i.readyState && 200 === i.status) try {
                n = JSON.parse(i.responseText);
            } catch (e) {
                !function(e) {
                    console.logRAError && console.logRAError("Error parsing the environment JSON file: " + e);
                }(e);
            } else o();
        }, i.onerror = o, i.open("GET", e, !1), i.send(), n;
        function o() {
            console.logRAError && console.logRAError("Error loading the environment JSON file: " + i.statusText);
        }
    };
}(), window.disney = window.disney || {}, window.disney.plugins = window.disney.plugins || {}, 
window.disney.plugins.logger = function(i, r) {
    for (var e in r._enableNativeLog = window.disney.device.embedded, r._enableDebugLog = window.disney.util.getCookie && !!window.disney.util.getCookie("enableNativeBridgeDebug"), 
    r.enableNativeLog = function(e) {
        r._enableNativeLog = e;
    }, r.enableDebugLog = function(e) {
        r._enableDebugLog = e;
    }, r.logRAError = function() {
        var e = r._enableNativeLog, n = (e && (r._enableNativeLog = !1), Array.prototype.slice.call(arguments));
        r.error.apply(r, n), r._enableNativeLog = e;
    }, r.logRADebug = function() {
        var e, n = r._enableNativeLog;
        r._enableDebugLog && (n && (r._enableNativeLog = !1), e = Array.prototype.slice.call(arguments), 
        r.debug.apply(r, e), r._enableNativeLog = n);
    }, r) r.hasOwnProperty(e) && "enableNativeLog" !== e && "logRADebug" !== e && "logRAError" !== e && "function" == typeof r[e] && !function(n) {
        var o = r[n];
        r[n] = function() {
            var e = [].slice.call(arguments);
            r._enableNativeLog && i.sendCustomMessage("LoggerPlugin.log", {
                level: n,
                args: e
            }), o.apply(r, e);
        };
    }(e);
}, window.disney = window.disney || {}, window.disney.plugins = window.disney.plugins || {}, 
window.disney.plugins.webErrorLogger = function(n, o) {
    var i, r = window.disney.util.getCookie && !!window.disney.util.getCookie("enableNativeBridgeDebug");
    o.enableNativeWebErrorLogging = function(e) {
        r = e;
    }, i = o.onerror, o.onerror = function() {
        var e = Array.prototype.slice.call(arguments);
        r && n.sendCustomMessage("WebErrorLoggerPlugin.log", {
            args: e
        }), i && i.apply(o, e);
    };
};
